import noop from 'lodash/noop'
import { Cookies } from 'react-cookie'

let cookieInstance: Cookies

// This handler is really just to avoid having to instantiate the library each time. Which doesn't
// really make sense until we start spinning up a SPA, but hey, at least then we'll be prepared, right?
const getCookieInstance = (): typeof cookieInstance => {
  if (!cookieInstance) {
    cookieInstance = new Cookies()
  }

  return cookieInstance
}

export const trackProductClick = (productID: string, variantID?: string, customerID?: string) => {
  // exclude events from gift card to recommendations
  if (productID === '26342') {
    return
  }

  try {
    fetch(
      `https://api.trendhim.com/v1/recommendation/track?${new URLSearchParams({
        track_type: 'product',
        customer_id: customerID || '',
        product_id: productID,
        user_id: getCookieInstance().get('th_uid') ?? '',
        variant_id: variantID || '',
      })}`,
      {
        method: 'GET',
      },
    ).catch(noop)
  } catch {
    // Do NOTHING! We don't care.
  }
}

